/**
 * Created by comoon on 1/27/16.
 */

var React = require("react");

var moment = require("moment");

var _ = require("underscore");

var StartCityList = require("../conf/start-city");

var Calendar = require("../cutil/Calendar.jsx");

var Tip = require("../cutil/Tip.jsx");

var HeadCount = require("../util/head-count");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, EventConstants} = require("../Constants");

var ALikeStore = require("../store/ALikeStore");

var {object2class} = require("../util/clazz");

var TripGrade = require("../conf/trip-grade");

var HCCalculator = HeadCount.Calculator;

var {AHEAD_MIN_DATE,AHEAD_MAX_DATE} = require('../conf/booking-conf');

module.exports = React.createClass({

    displayName: "QuoteApplyForm",

    getInitialState(){
        var tripInfo = ALikeStore.get_tripBasicInfo();

        if(tripInfo.visaDay!==''){
            AHEAD_MIN_DATE = +tripInfo.visaDay;
        }

        var hcCalculator = new HeadCount.Calculator(true);

        var hasCar = this.props.hasCar;

        var formData = {
            grade: ALikeStore.get_gradeType(),
            startDate: moment().add(50, 'days').format("YYYY-MM-DD"),
            startCity: null,
            defaultStart: true
        };

        var previous = this.props.formData;

        if (previous) {


            formData = _.pick(previous, 'grade', 'startDate', 'startCity', 'inquiryKey');

            hcCalculator.update(HCCalculator.Type.adult, previous.adtCnt)
                .update(HCCalculator.Type.child, previous.chdCnt)
                .update(HCCalculator.Type.room, previous.roomCnt)
                .update(HCCalculator.Type.car, previous.carCnt);

        } else {

            hcCalculator.update(HCCalculator.Type.adult, 2).update(HCCalculator.Type.room, 1);

            if (hasCar) {

                hcCalculator.update(HCCalculator.Type.car, 1);
            }
        }

        return {
            hasCar,
            hcCalculator,
            formData
        }
    },
    componentWillReceiveProps(nextProps){
        if (nextProps.formData) {

            var previous = nextProps.formData;

            if (previous.inquiryKey !== this.state.formData.inquiryKey) {

                var formData = _.pick(previous, 'grade', 'startDate', 'startCity', 'inquiryKey');

                var hcCalculator = this.state.hcCalculator;

                hcCalculator.update(HCCalculator.Type.adult, previous.adtCnt)
                    .update(HCCalculator.Type.child, previous.chdCnt)
                    .update(HCCalculator.Type.room, previous.roomCnt)
                    .update(HCCalculator.Type.car, previous.carCnt);

                this.setState({formData, hcCalculator});
            }
        }
    },
    componentWillMount(){
        ALikeStore.on(EventConstants.AJAX_COMMIT_APPLY_COMPLETE, this.on_commitApplyComplete);
        ALikeStore.on(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);
        ALikeStore.on(EventConstants.AJAX_SEARCH_PORT_INFO_COMPLETE, this.on_searchPortInfoComplete);
        ALikeStore.on(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE_CONFIRM, this.on_selectedStartDate);
    },
    componentWillUnmount(){
        ALikeStore.off(EventConstants.AJAX_COMMIT_APPLY_COMPLETE, this.on_commitApplyComplete);
        ALikeStore.off(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);
        ALikeStore.off(EventConstants.AJAX_SEARCH_PORT_INFO_COMPLETE, this.on_searchPortInfoComplete);
        ALikeStore.off(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE_CONFIRM, this.on_selectedStartDate);
    },
    componentDidMount(){
        var commit = this.props.commit;
        var startDate = ALikeStore.get_selectedStartDate();

        if(commit){
            var selected = startDate.selected;
            var formData = this.state.formData;
            formData.startDate = selected.format('YYYY-MM-DD');
            formData.defaultStart = false;
            this.setState({formData},function(){
                this.handle_commitApply();
            });

        }
    },
    on_commitApplyComplete(){
        this.setState({committing: false});
    },
    on_switchGradeComplete(){
        var gradeType = ALikeStore.get_gradeType();
        var formData = this.state.formData;
        formData.grade = gradeType;
        this.setState({formData})
    },
    on_searchPortInfoComplete(){
        var portInfo = ALikeStore.get_portInfo();
        var formData = this.state.formData;
        formData.startCity = portInfo[0].poi;
        this.setState({formData})
    },
    on_selectedStartDate(){

        var self = this;
        setTimeout(function(){
            self.handle_commitApply();
        },0)

    },
    handle_toggleTripGrade(gradeType){
        var formData = this.state.formData;
        formData.grade = gradeType;

        var tripInfo = ALikeStore.get_tripBasicInfo();
        var versionId = gradeType === TripGrade.Enjoy.code ? tripInfo.versionId : tripInfo.luxuryVersionId ;
        var data = {
            versionId: versionId,
            gradeType: gradeType
        };
        Dispatcher.dispatch({type: ActionConstants.SWITCH_GRADE_TYPE, data: data});
    },
    handle_selectDepartDate(options){
        var formData = this.state.formData;
        formData.startDate = options.string;
        formData.defaultStart = false;
        this.setState({formData});
    },
    handle_chooseStartCity(city){
        var formData = this.state.formData;
        formData.startCity = city.id;
        this.setState({formData});
    },
    handle_changeAdultCount(event){
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.adult, event.target.value);
        this.setState({hcCalculator: calculator});
    },
    handle_changeChildCount(event) {
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.child, event.target.value);
        this.setState({hcCalculator: calculator});
    },
    handle_changeRoomCount(event) {
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.room, event.target.value);
        this.setState({hcCalculator: calculator});
    },
    handle_changeCarCount(event) {
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.car, event.target.value);
        this.setState({hcCalculator: calculator});
    },
    handle_fieldChange(event){

        var formData = this.state.formData;

        var name = event.target.name;

        if (event.target.type === 'checkbox') {
            formData[name] = event.target.checked ? 1 : 0;
        } else {
            formData[name] = event.target.value;
        }
        this.setState({formData});
    },

    handle_commitApply(){
        var self = this;
        var uid = $('.alike-container').data('uid');
        var defaultStart = self.state.formData.defaultStart;
        if( defaultStart ){
            $.cpWin.alert({
                type:'hintErr',
                msg: '请选择出发日期！'
            });
            return;
        }
        if(!uid){

            self.handle_mobileLogin();

        } else {

            self.handle_quoteConfirm();

        }
    },
    handle_closeConfirm(){
        var confirmWin = $('.dialog-quote-confirm').cpGetCtr("cpDialog");
        confirmWin.close();
    },
    handle_mobileLogin(){
        var self = this;
        window.FORWARD_URL_DISABLE = true;
        $.cpWin.mobileLogin({
            title:'实时获取价格',
            infoTxt:'请填写手机号码，计价完成后第一时间以短信形式通知到你',
            submitBtnTxt:'提交',
            loginHandle:function(user){
                self._handle_commitApply();
                $('.alike-container').data('uid', user.uid);
                $.cpEvt.send("login_login_success", user);
            }
        });
        _TongjiLog("cxdhtclx1","准AAPC出现电话弹窗类型1");

        $('.js_mobile_login_dialog').on('click','.js_send_vcode',function(e){

            _TongjiLog("tjhqyzm_vtel_NNN","准AAPC提交获取验证码_vtel_NNNN");

        }).on('click','.js_form_2_submit',function(){

            var sendVcodeTxt = $('.js_send_vcode').html();

            if(sendVcodeTxt==='验证码'){
                _TongjiLog("ldhtclx1_djtj_utel_NNN","准AAPC_点击提交未验证电话_utel_NNNN");
            }else{
                _TongjiLog("ldhtclx1_djtj_tel_NNN","准AAPC_点击提交已验证电话_tel_NNNN");
            }

        });
    },
    handle_quoteConfirm(){
        var self = this;
        var tripInfo = ALikeStore.get_tripBasicInfo();

        var userMobile = tripInfo.currentUserMoblie || '';
        var userLeftQueryCnt = ALikeStore.get_leftQueryCnt() || 0;
        var formData = self.state.formData;
        var startDate = formData.startDate;
        var startCity = formData.startCity;
        var startCityName = ALikeStore.get_startCityName(startCity);
        var hcCalculator = self.state.hcCalculator;
        var adult = hcCalculator.adult.current;
        var child = hcCalculator.child.current;
        var room = hcCalculator.room.current;
        var car = hcCalculator.car.current;
        var hasCar = self.state.hasCar;
        var carHtml = hasCar ? '，<span>'+car+'</span>辆车</div>' : ''
        var car  = hasCar ? '，<span>{car}</span>辆车</div>' : '';
        var leftQueryHtml = userLeftQueryCnt>0
            ? '<div>今天您还可以对该线路申请 <span>'+userLeftQueryCnt+'</span>次计价，计价完成之后将会 <br/> 短信通知到您<span>'+userMobile+'</span>的手机上</div>'
            : '<div>今天您还可以对该线路申请 <span>'+userLeftQueryCnt+'</span>次计价，<span>不能再提交了！</span>'
        var quoteInfoHtml = '' +
            '<div>出发日期：<span>'+ startDate +'</span></div>' +
            '<div>出发口岸：<span>'+ startCityName +'</span></div>' +
            '<div>数量：<span>'+ adult +'</span>成人，<span>'+ child +'</span>儿童，<span>'+ room +'</span>间房' + carHtml +
            '' +leftQueryHtml;
        var QuoteInfo = function(){
            return(
                <div>
                    <div>出发日期：</div>
                    <div>出发口岸：</div>
                    <div>数量：<span>{adult}</span>成人，<span>{child}</span>儿童，<span>{room}</span>间房{car}</div>
                    <div>该线路今天您还可以提交 <span>3</span>次计价需求，计价完成后将通知以 <br/> 短信形式发送到<span>'+userMobile+'</span></div>
                </div>
            )
        }
        $.cpWin.confirm({
            title: '实时获取价格',
            msg: "您将提交一个实时计价需求：",//提示文字
            attachInfo: quoteInfoHtml,//附加信息
            subBtnTxt:'确定提交',//确定按钮文字
            subHandle: function(){
                if( userLeftQueryCnt==0 ){
                    return
                }

                self._handle_commitApply();

            },//点确定回调函数
            dialogClass: 'dialog-quote-confirm'
        });

        if( userLeftQueryCnt==0 ){
            $('.btn-primary').hide();
        }else{
            $('.btn-primary').show();
        }

    },

    _handle_commitApply(){

        var params = _.extend({}, this.state.formData, this.state.hcCalculator.toShort());

        Dispatcher.dispatch({type: ActionConstants.COMMIT_APPLY, data: params});

        this.setState({committing: true});
    },
    _getStartCityList(){
        var formData = this.state.formData;
        var startCityList = _.first(StartCityList, 4) || [];
        var portInfo = ALikeStore.get_portInfo();
        var isNewCity = !_.findWhere(startCityList, {id: formData.startCity}) ? true : false;
        if(formData.startCity && isNewCity){
            var city = _.findWhere(portInfo,{poi: formData.startCity});
            var newCity = {
                id: city.poi,
                name: city.name
            }
            if(startCityList.length>4){
                startCityList = _.initial(startCityList);
            }else{
                startCityList.push(newCity);
            }
        }
        return startCityList;
    },
    render_form(){

        var self = this;
        var state = this.state;
        var formData = state.formData;
        var calculator = state.hcCalculator;
        var gradeType = formData.grade;
        var startCityList = this._getStartCityList();

        return (

            <ul className="field-set">
                {state.committing ? (<div className="cover"></div>) : null}
                <li className="field grade-field">
                    <div className="grade enjoy-grade pull-left" onClick={e=> this.handle_toggleTripGrade(0)}>
                        <i className={(gradeType === 0) ? "icon-radio icon-indicator-radio-checked" : "icon-radio icon-indicator-radio"}/>
                        <label className="p-p5">品质旅行</label>
                    </div>
                    <div className="grade luxury-grade pull-left m-ml5"
                         onClick={e=> this.handle_toggleTripGrade(1)}>
                        <i className={(gradeType === 1) ? "icon-radio icon-indicator-radio-checked" : "icon-radio icon-indicator-radio"}/>
                        <label className="p-p5">优选旅行</label>
                    </div>
                    <div className="clearfix"></div>
                </li>
                <li className="field date-field vm-wrapper">
                    <label>选择出发日期</label>
                        <span className="p-p5">
                            <Calendar title="请选择出发日期" onSelect={this.handle_selectDepartDate}
                                      selected={formData.startDate}
                                      defaultStart={formData.defaultStart}
                                      min={moment().add(AHEAD_MIN_DATE, 'days')}
                                      max={moment().add(AHEAD_MAX_DATE, 'days')}
                            />
                        </span>
                </li>
                <li className="field port-field">
                    <label className="lab-city">出发城市<i className="icon-indicator-all-arr"></i></label>
                        <span className="start-city-list">
                            {
                                _.map(startCityList, function (city) {

                                    var checkClass = "icon-radio icon-indicator-radio" + ((formData.startCity === city.id) ? "-checked" : "");
                                    var cityName = city.name.replace("市","");
                                    return (
                                        <div className="start-city pull-left p-pl5" key={city.id}
                                             onClick={()=>{self.handle_chooseStartCity(city)}}>
                                            <i className={checkClass}/>
                                            <label className="p-pl5">{cityName}</label>
                                        </div>
                                    );
                                })
                            }

                            <Tip trigger={<div className="more-city c-blue"><span>更多</span><i className="icon-indicator-arr-down-b"></i> </div>} enter>
                                {self.render_portInfo()}
                            </Tip>
                            <div className="clearfix"></div>
                        </span>
                </li>
                <li className={"field head-count-field" + (state.hasCar ? ' has-car': '')}>
                    <div className="head-count adult-hc pull-left">
                        <div className="title">
                            成人
                        </div>
                        <div className="cell-select">
                            <select className="hc-selector" name="adultCount"
                                    value={calculator.adult.current}
                                    onChange={this.handle_changeAdultCount}>
                                {
                                    _.map(_.range(calculator.adult.min, calculator.adult.max + 1), function (count) {

                                        return (
                                            <option key={count} value={count}>{count}</option>
                                        );
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="head-count child-hc pull-left">
                        <div className="title">
                            儿童&nbsp;
                            <Tip trigger={(<i className="icon-super-detail-info" />)}>
                                <div className="c-tip-content">
                                    <div className="c-head">
                                        <i className="icon-super-detail-tip-1"/>
                                        儿童年龄说明
                                    </div>
                                    <div className="c-body">
                                        在接受服务时，儿童的年龄在2~12岁之间，超过12岁被视为成年人。
                                    </div>
                                </div>
                            </Tip>
                        </div>
                        <div className="cell-select">
                            <select className="hc-selector" name="childCount"
                                    value={calculator.child.current}
                                    onChange={this.handle_changeChildCount}>
                                {
                                    _.map(_.range(calculator.child.min, calculator.child.max + 1), function (count) {

                                        return (
                                            <option key={count} value={count}>{count}</option>
                                        );
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="head-count room-hc pull-left">
                        <div className="title">
                            房间
                        </div>
                        <div className="cell-select">
                            <select className="hc-selector" name="roomCount"
                                    value={calculator.room.current}
                                    onChange={this.handle_changeRoomCount}>
                                {
                                    _.map(_.range(calculator.room.min, calculator.room.max + 1), function (count) {

                                        return (
                                            <option key={count} value={count}>{count}</option>
                                        );
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    {
                        state.hasCar ? (
                            <div className="head-count car-hc pull-left">
                                <div className="title">
                                    车辆
                                </div>
                                <div className="cell-select">
                                    <select className="hc-selector" name="carCount"
                                            value={calculator.car.current}
                                            onChange={this.handle_changeCarCount}>
                                        {
                                            (calculator.car.min > 0 && !state.hasCar) ? (
                                                <option key="0" value={0}>0</option>) : null
                                        }
                                        {
                                            _.map(_.range(calculator.car.min, calculator.car.max + 1), function (count) {

                                                return (
                                                    <option key={count} value={count}>{count}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        ) : null
                    }
                    <div className="clearfix"></div>
                </li>
            </ul>
            
        )
        
    },

    render_submit(){

        var state = this.state;
        var expired = this.props.expired;
        
        return (
            <div className="op-feed">
                {expired ? (
                    <div className="strong-hint">
                        价格已过期
                    </div>
                ) : null}
                <div className="error-msg">{ALikeStore.get_errorMsg(ActionConstants.COMMIT_APPLY)}</div>
                <button className="btn bt-orange btn-commit-quote"
                        onClick={state.committing ? null : this.handle_commitApply}>
                    {state.committing ? '提交中…' : expired ? '重新计价' : '实时计价'}
                </button>
                <br/>
                <br/>
                <div>
                    {expired ?
                        (<span><i className="icon-indicator-tip-gray"/>&nbsp;&nbsp;因为机票的价格会有波动，为了保证客户不受损失，报价有严格有效时间。</span>) :
                        (
                            <span><i className="icon-indicator-tip-gray"/>
                                &nbsp;&nbsp;为了保证价格实时有效，所选日期价格需要实时计算。你可拨打4006-86-5060或者在线提出询价要求。</span>
                        )}
                    {this.render_contact()}
                </div>
            </div>
        )
        
    },
    /**
     * 渲染二级口岸
     * @returns {XML}
     */
    render_portInfo(){
        var portInfo = ALikeStore.get_portInfo();
        if(!portInfo){
            return
        }
        var self = this;
        var formData = this.state.formData;
        var defaultClass = "icon-radio icon-indicator-radio" + ((formData.startCity === portInfo[0].poi) ? "-checked" : "");
        var defaultCity = {
            id: portInfo[0].poi,
            name: portInfo[0].name
        }
        var defaultItem = (
            <div>
                <div className="start-city pull-left p-pl5" key={portInfo[0].poi}
                     onClick={()=>{self.handle_chooseStartCity(defaultCity)}}>
                    <i className={defaultClass}/>
                    <label className="p-pl5">{portInfo[0].name}</label><span className="txt">实时计价</span>
                </div>
                <div className="c-red info">根据所在IP地址为您推荐</div>
            </div>
        );
        var item = _.map(portInfo,function(item,index){
            if(index ==0){
                return
            }
            var checkClass = "icon-radio icon-indicator-radio" + ((formData.startCity === item.poi) ? "-checked" : "");
            var city = {
                id: item.poi,
                name: item.name
            }
            return(
                <li key={index}>
                    <div className="start-city pull-left p-pl5" key={item.poi}
                         onClick={()=>{self.handle_chooseStartCity(city)}}>
                        <i className={checkClass}/>
                        <label className="p-pl5">{item.name}</label><span className="txt">实时计价</span>
                    </div>
                </li>
            )
        })
        return(
            <div className="c-tip-content quote-hint-box city-list-wrap">
                <div className="c-head">
                    <i className="icon-super-detail-tip-2"/>
                    全国出发口岸城市
                    <i className="icon-indicator-all-arr2"></i>
                </div>
                <div className="c-body">
                    <div className="city-list-box default-city">
                        {defaultItem}
                    </div>
                    <ul className="city-list-box">
                        {item}
                    </ul>
                </div>

                <div className="c-footer">
                    <p className="info f-s">
                        *以上城市均达到行程大师航班选择标准，您可点击实时计价查看价格。如需其它城市出发，建议您<strong>在线咨询</strong>或拨打<strong>4006-86-5060</strong>。
                    </p>
                </div>

            </div>
        )
    },
    render_contact(){
        return(
            this.props.renderContact(false, true)
        );
    },

    render(){
        
        var state = this.state;

        var formClazz = object2class({
            'quote-apply-form': true,
            committing: state.committing
        });
        return (
            <div className={formClazz}>
                { this.render_form() }
                {this.render_submit()}
            </div>
        );
    }
});
 



/** WEBPACK FOOTER **
 ** ./script/detail/QuoteApplyForm.jsx
 **/